/* eslint-disable dot-notation */

/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useCallback, useEffect, useState} from 'react';
import {
  FlatList,
  InteractionManager,
  Platform,
  RefreshControl,
  StyleSheet,
  useWindowDimensions,
  View,
} from 'react-native';
import {
  ActivityIndicator,
  Button,
  Card,
  IconButton,
  List,
  Text,
} from 'react-native-paper';
import {errorHandler, prepareDataForFlatList} from '../services/Utils';
import {theme} from '../theme/theme';
import moment from 'moment';
import {DatePickerModal} from 'react-native-paper-dates';
import {useDispatch, useSelector} from 'react-redux';
import {showToast} from '../store/info.slice';
import * as BluetoothPrintService from '../services/BluetoothPrintService';
import {SafeAreaView} from 'react-native-safe-area-context';
import {printCountersReport} from '../services/PrintService';
import {ReportsApiService} from '../services/ReportsApiService';

const getNumColumns = width => {
  if (width < 500) {
    return 1;
  }
  if (width < 576) {
    return 2;
  }
  if (width < 768) {
    return 2;
  }
  if (width < 992) {
    return 3;
  }
  if (width < 1200) {
    return 4;
  }
  if (width < 1400) {
    return 5;
  }
  return 5;
};

function CountersReport({navigation}) {
  const {width} = useWindowDimensions();
  const dispatch = useDispatch();
  const customer = useSelector(state => state.customer?.customer);
  const numColumns = getNumColumns(width);
  const [interactionCompleted, setIntersectionCompleted] = useState(false);
  const [report, setReport] = useState([]);
  const [status, setStatus] = useState('idle');
  const [setError] = useState(null);
  const [page, setPage] = useState(1);
  const [loadingMore, setLoadingMore] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const LIMIT = 36;
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const [selectedDate, setSelectedDate] = useState(today);
  const [openDatePicker, setOpenDatePicker] = useState(false);

  const onDismissSingle = useCallback(() => {
    setOpenDatePicker(false);
  }, [setOpenDatePicker]);

  const onConfirmSingle = React.useCallback(
    params => {
      setOpenDatePicker(false);
      setSelectedDate(params.date);
    },
    [setOpenDatePicker, setSelectedDate],
  );

  const fetchData = ({action = 'view', format = 'json'} = {}) => {
    setRefreshing(false);
    setStatus('loading');
    const params = {
      action,
      format,
      page,
      cafe_id: customer?.cafe_id,
      limit: LIMIT,
      fromDate: moment(selectedDate).format('YYYY-MM-DD'),
      toDate: moment(selectedDate).format('YYYY-MM-DD'),
    };
    ReportsApiService.get('/cash-counter/counters', {params})
      .then(response => {
        if (action === 'download') {
          if (response.data?.length === 0) {
            return dispatch(showToast('No data available to print'));
          }
          const report_params = {
            report_name: 'Counters Report',
            cafe_name: customer?.cafe_name,
            login_at: customer?.logged_in_time
              ? moment(customer.logged_in_time).format('llll')
              : moment().format('llll'),
            reporting_time: moment().format('llll'),
            items: response.data,
            customer_name: `${customer?.cust_name ?? ''} ${
              customer?.cust_last_name ?? ''
            }`.trim(),
          };
          if (Platform.OS === 'web') {
            printCountersReport(report_params);
          } else if (Platform.OS === 'android') {
            BluetoothPrintService?.printCountersReport(report_params);
          }
          return;
        }
        setStatus('succeeded');
        setRefreshing(false);
        const len = response.data['reports'].length;
        if (len > 0 && len >= LIMIT) {
          setLoadingMore(true);
        } else {
          setLoadingMore(false);
        }
        const temp =
          page === 1
            ? response.data['reports']
            : report.concat(response.data['reports']);
        setReport(
          prepareDataForFlatList({
            numColumns,
            key: 'canteen_name',
            page,
            data: temp,
          }),
        );
      })
      .catch(_error => {
        setStatus('failed');
        setRefreshing(false);
        setLoadingMore(false);
        setError(_error);
        errorHandler(_error);
      });
  };

  useEffect(() => {
    const task = InteractionManager.runAfterInteractions(async () => {
      setIntersectionCompleted(true);
    });
    return () => {
      task.cancel();
    };
  }, []);

  useEffect(() => {
    if (interactionCompleted && status !== 'loading') {
      fetchData();
    }
  }, [interactionCompleted, page, selectedDate]);

  useEffect(() => {
    if (interactionCompleted) {
      setStatus('idle');
      setPage(1);
      setReport([]);
    }
  }, [interactionCompleted, selectedDate]);

  const renderItem = ({item, index}) => {
    if (item?.isEmpty) {
      return <View style={{flex: 1}} />;
    }
    return (
      <View style={{flex: 1, margin: 1}}>
        <List.Item
          style={{backgroundColor: '#fff'}}
          title={item?.canteen_name}
          titleStyle={{fontSize: 12}}
          titleNumberOfLines={null}
          description={
            <View>
              <Text style={{fontSize: 14}}>
                Counter: {item?.counter}
              </Text>
              <Text style={{fontSize: 12}}>
                Total Qty: {item?.total_orders}
              </Text>
              <Text style={{fontSize: 12}}>
                Total Amount: {item?.total_order_amount}
              </Text>
            </View>
          }
        />
      </View>
    );
  };

  const _refreshControl = () => {
    return (
      <RefreshControl
        colors={[theme.colors.primary]}
        refreshing={refreshing}
        onRefresh={() => _onRefresh()}
      />
    );
  };

  const _onRefresh = retry => {
    setStatus('idle');
    setPage(1);
    setReport([]);
    fetchData();
  };

  const _handleLoadMore = () => {
    if (loadingMore && status !== 'loading' && report.length > 0) {
      setStatus('idle');
      setPage(_p => _p + 1);
    }
  };

  const ListFooterComponent = () => {
    if (!loadingMore) {
      return null;
    }
    return (
      <View style={{padding: 16}}>
        <ActivityIndicator animating={true} color={theme.colors.primary} />
      </View>
    );
  };

  const ListHeaderComponent = () => {
    return (
      <Card
        elevation={0}
        style={{
          margin: 0,
          marginBottom: 2,
          padding: 0,
          borderRadius: 0,
          backgroundColor: '#ffffff',
        }}>
        <Card.Title
          style={{flex: 1}}
          titleStyle={{fontSize: 14}}
          subtitleStyle={{fontSize: 12}}
          title="Select Date"
          subtitle={moment(selectedDate).format('MMMM D, YYYY')}
          //   right={props => (
          //     <IconButton
          //       icon={'calendar-range'}
          //       onPress={() => setOpenDatePicker(t => !t)}
          //     />
          //   )}
        />
      </Card>
    );
  };

  return (
    <SafeAreaView edges={['bottom']} style={styles.container}>
      {interactionCompleted && (
        <React.Fragment>
          <View style={styles.mainContainer}>
            {/* {ListHeaderComponent()} */}
            <FlatList
              data={report}
              renderItem={renderItem}
              keyExtractor={(item, index) => index.toString()}
              onEndReached={_handleLoadMore}
              onEndReachedThreshold={0.1}
              refreshControl={_refreshControl()}
              ListFooterComponent={ListFooterComponent}
              ListHeaderComponent={ListHeaderComponent}
              key={numColumns}
              numColumns={numColumns}
              columnWrapperStyle={numColumns > 1 ? {gap: 1} : undefined} // RN 0.71+
            />
            {/* <DatePickerModal
                            locale="en"
                            mode="single"
                            validRange={{ endDate: today }}
                            visible={openDatePicker}
                            onDismiss={onDismissSingle}
                            date={selectedDate}
                            onConfirm={onConfirmSingle}
                            presentationStyle={'pageSheet'}
                            saveLabel={'Submit'}
                        /> */}
          </View>
          {customer?.customer_settings?.enable_printing_counters_report &&
            Platform.OS !== 'web' && (
              <View style={styles.footer}>
                <Button
                  mode="contained"
                  style={{margin: 4}}
                  onPress={() => fetchData({action: 'download'})}>
                  Print
                </Button>
              </View>
            )}
        </React.Fragment>
      )}
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f1f1f3',
  },
  mainContainer: {
    flex: 1,
  },
  footer: {
    position: Platform.OS === 'web' ? 'sticky' : undefined,
    bottom: 0,
    width: '100%',
  },
});

export default CountersReport;
